// Dates as the API wants them: a plain "yyyy-MM-dd", in the user's own calendar (never shifted through UTC).

export function toDateOnlyString(value: Date): string {
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${value.getFullYear()}-${month}-${day}`;
}

// A form's date value (text typed in, or the Date a date picker gives) as "yyyy-MM-dd"; nothing when it is empty.
export function toNullableDateString(value: string | Date | null | undefined): string | null {
  if (!value) {
    return null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }

  return toDateOnlyString(value);
}

// "Now" as a date ("yyyy-MM-dd") and a time ("HH:mm"), for a form that starts at the current moment.
export function currentDateAndTime(now = new Date()): { date: string; time: string } {
  return {
    date: toDateOnlyString(now),
    time: `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`,
  };
}
